import { render, staticRenderFns } from "./AddNewParamaBundle.vue?vue&type=template&id=7fe2e707"
import script from "./AddNewParamaBundle.vue?vue&type=script&lang=js"
export * from "./AddNewParamaBundle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports